import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["placeholder", "loading"]
  static values  = { entryId: Number, aircraftId: Number }

  submit(event) {
    event.preventDefault()

    if (this.hasPlaceholderTarget) this.placeholderTarget.classList.add("d-none")
    this.loadingTarget.classList.remove("d-none")

    fetch(this.auditPath, {
      method: "POST",
      headers: { "X-CSRF-Token": this.csrfToken }
    })

    this.pollForResult()
  }

  pollForResult() {
    this.pollInterval = setInterval(async () => {
      const response = await fetch(this.statusPath)
      const data     = await response.json()

      if (data.ready) {
        clearInterval(this.pollInterval)
        Turbo.visit(window.location.href, { action: "replace" })
      }
    }, 2000)
  }

  disconnect() {
    if (this.pollInterval) clearInterval(this.pollInterval)
  }

  get auditPath() {
    return `/aircrafts/${this.aircraftIdValue}/logbooks/${this.entryIdValue}/audit`
  }

  get statusPath() {
    return `/aircrafts/${this.aircraftIdValue}/logbooks/${this.entryIdValue}/compliance_status`
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content
  }
}
